/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReportRow } from './types'

export default function createReportContent(
    events: Array<any>,
    addressMap: { [key: string]: { [key: string]: string } }
): { content: Array<ReportRow> } {
    const content = []
    events.forEach(event => {
        const row = {
            __lat: event.__lat,
            __lng: event.__lng,
            dateHour: event?.['Data/Hora'],
            plate: event.placa,
            odometer: event.odometro,
            ignition: event?.['Ignição'],
            latLng: event?.['Lat/Lng'],
            speed: event?.['Velocidade (Km/H)'],
            chassis: event.chassi,
            address: addressMap[`${event.__lat},${event.__lng}`]?.address,
            city: addressMap[`${event.__lat},${event.__lng}`]?.city,
            state: addressMap[`${event.__lat},${event.__lng}`]?.state,
            provider: event?.fornecedor
        }

        content.push(row)
    })

    return { content }
}

export const getXLSX = async (obj: { content: ReportRow[] }): Promise<void> => {
    await fetch('services/plugin-positions-report/resource/export-xlsx', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify([...obj.content])
    })
        .then(response => {
            return new Response(response.body)
        })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = 'Relatorio.xlsx'
            a.click()
        })
}

export const getEventFieldsList = (eventsFields: Record<string, unknown>): Array<string> => {
    return Object.keys(eventsFields)
}

export const fetchApi = (method, url) => {
    return fetch(url, {
        method: method,
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(response => {
        if (!response.ok) return response

        return response.text().then(text => {
            try {
                return { data: JSON.parse(text), ok: response.ok }
            } catch (err) {
                return text
            }
        })
    })
}

export const transformKeys = (hopNumber, obj) => {
    const transformed = obj.reduce((total, current, index) => {
        return { ...total, [index + 100 * hopNumber]: { ...current } }
    }, {})
    return transformed
}

export const formatAddress = addressComponents => {
    if (addressComponents.length === 0) return ''
    const aux = []
    addressComponents.forEach(ele => {
        ele.types.forEach(type => {
            if (type.toLowerCase() === 'route' || type.toLowerCase() === 'sublocality') {
                aux.push(ele.longName)
            }
        })
    })
    return aux.join(', ')
}

export const getCity = addressComponents => {
    if (addressComponents.length === 0) return ''
    let city = null
    addressComponents.forEach(ele => {
        if (ele.types.includes('ADMINISTRATIVE_AREA_LEVEL_2')) city = ele.longName
    })
    return city
}

export const getState = addressComponents => {
    if (addressComponents.length === 0) return ''
    let state = null
    addressComponents.forEach(ele => {
        if (ele.types.includes('ADMINISTRATIVE_AREA_LEVEL_1')) state = ele.longName
    })
    return state
}
